export class AdesaoModel{
    codPlano:number;
    cpf:string;
    rg:string;
    emailSec:string;
    codEstadoCivil:number;
    endereco:string;
    compl:string;
    bairro:string;
    codCidade:number;
    cep:string;
    DDITelef:string;
    DDDTelef:string;
    telef:string;
    DDITelCom:string;
    DDDTelCom:string;
    TelCom:string;
    codFormaPgto:string;
    diaPgto:number;
    vlrCtb:number;
    idadeApos:number;
    decPPE:string;
    decTributacao:string;
    decInstituidor:string;
    idcPais:string;
    decUSPerson:string;
    idcAutDadosPessoais:string;
    recidenciaFiscal:string;
    nif:string;
    nacionalidade:string;
    conta:string;
    contaDv:string;
    banco:string;
    agencia:string;
    agenciaDv:string;
    genero:string;
    dataNascimento:string;
    cpfAssociado:string;
    nomeAssociado:string;
    emailAssociado:string;
    DDICelularAssociado:string;
    DDDCelularAssociado:string;
    CelularAssociado:string;
    CodParentescoAssociado:number;
}